import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    label: 'Dashboard',
    icon: 'home',
    link: '/dashboard',
    disabled: true,
  },
  {
    label: 'Smart Cart',
    icon: 'shopping-cart',
    link: '/smart-cart',
    disabled: true,
  },
  {
    label: 'Purchases',
    icon: 'download',
    subItems: [
      {
        label: 'Purchase Orders',
        link: '/purchase-order/view',
        disabled: true,
      },
      {
        label: 'New Purchase Order',
        link: '/purchase-order/create',
        disabled: true,
      },
      {
        label: 'Vendor Bills',
        link: '/purchase-order/bills/view',
        disabled: true,
      },
      {
        label: 'New Bill',
        link: '/purchase-order/bills/standalone',
        disabled: true,
      },
      {
        label: 'Master Bill View',
        link: '/purchase-order/all-bills',
        disabled: true,
      },
    ],
    disabled: true,
  },
  {
    label: 'Sales',
    icon: 'upload',
    subItems: [
      {
        label: 'Sales Order',
        link: '/sale-order/view',
        disabled: true,
      },
      {
        label: 'New Sales Order',
        link: '/sale-order/create',
        disabled: true,
      },
      {
        label: 'Invoices',
        link: 'sale-order/invoices',
        disabled: true,
      },
    ],
    disabled: true,
  },
  {
    label: 'Manage Inventory',
    icon: 'archive',
    subItems: [
      {
        label: 'Inventory Log',
        link: '/inventory/log',
        disabled: true,
      },
      {
        label: 'Closing Inventory',
        link: '/inventory/close',
        disabled: true,
      },
      {
        label: 'Ingredients Wastage',
        link: '/inventory/wastage',
        disabled: true,
      },
      {
        label: 'Recipe Wastage',
        link: '/inventory/wastage-recipe',
        disabled: true,
      },

      {
        label: 'Staff Consumption',
        link: '/inventory/staff-consumption',
        disabled: true,
      },
      {
        label: 'Templates',
        link: '/inventory/templates',
        disabled: true,
      },

      {
        label: 'POS Orders',
        link: '/inventory/pos',
        disabled: true,
      },

      {
        label: 'Stock Control',
        link: '/inventory/stock-control',
        disabled: true,
      },
      {
        label: 'Bulk Sales',
        link: '/inventory/bulk-sales',
        disabled: true,
      },
    ],
    disabled: true,
  },
  {
    label: 'Plannings',
    icon: 'sliders',
    subItems: [
      {
        label: 'Production Plans',
        link: '/planning/list',
        disabled: true,
      },
      {
        label: 'New Production Plan',
        link: '/planning/create',
        disabled: true,
      },
    ],
    disabled: true,
  },

  {
    label: 'Products',
    icon: 'book-open',
    subItems: [
      {
        label: 'Products',
        link: '/products/all',
        disabled: true,
      },
      {
        label: 'New Product',
        link: '/products/create/product',
        disabled: true,
      },
      {
        label: 'Raw Material',
        link: '/products/raw-materials',
        disabled: true,
      },
      // {
      //   label: 'Sub Recipes',
      //   link: '/products/sub-recipes',
      //   disabled: true,
      // },
      {
        label: 'Recipes',
        link: '/products/recipes',
        disabled: true,
      },
      {
        label: 'Product Categories',
        link: '/products/categories',
        disabled: true,
      },
      {
        label: 'Product Integrations',
        link: '/products/integrations',
        disabled: true,
      },

      // {
      //   label: 'Packaging',
      //   link: '/products/packaging',
      //   disabled: true,
      // },
      // {
      //   label: 'Others',
      //   link: '/products/others',
      //   disabled: true,
      // },
    ],
    disabled: true,
  },
  {
    label: 'Contacts',
    icon: 'mail',
    subItems: [
      {
        label: 'Contacts',
        link: '/contacts/all',
        disabled: true,
      },
      {
        label: 'Vendors',
        link: '/contacts/vendor',
        disabled: true,
      },
      {
        label: 'Customers',
        link: '/contacts/customer',
        disabled: true,
      },
      {
        label: 'Employees',
        link: '/contacts/staff',
        disabled: true,
      },
      // {
      //   label: 'Create',
      //   link: '/contacts/create',
      //   disabled: true,
      // },
    ],
    disabled: true,
  },

  {
    label: 'Reports',
    icon: 'bar-chart-2',
    link: '/reports',
    disabled: true,
  },
];
